<template lang="pug">
  .address-form
    component.preview(:is="component" v-bind="properties" @click.prevent.stop="select")
      slot(name="icon")
        .icon
          svg(
            v-if="active"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            )
          .empty-checkbox(v-else)
            .circle
      .data
        .field-preview
          .label(v-if="showLabel") {{ label }}
          .field-value
            p.text-gray-500(v-if="showName") {{ name }}
            p {{ oneLiner }}
    hr.my-4(v-if="showDivider")
</template>

<script>
import { mapGetters } from 'vuex';
import { get, trim } from '@/helpers';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(de);

export default {
  name: 'Address',
  props: {
    data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    showDivider: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'billing'
    },
    label: {
      type: String,
      default: 'Adresse'
    },
    showName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      let component = 'a';
      if (this.active) component = 'div';
      return component;
    },
    properties() {
      let properties = {};
      if (this.component === 'a') {
        properties.href = '#';
      }
      return properties;
    },

    memberSalutation() {
      let salutation = '';
      if (this.member.gender === 'M') salutation = 'Herr';
      else if (this.member.gender === 'F') salutation = 'Frau';
      return salutation;
    },

    memberFirstName() {
      return get(this.member, 'first_name', '');
    },
    memberLastName() {
      return get(this.member, 'last_name', '');
    },

    name() {
      let name = trim(`${this.memberSalutation} ${this.memberFirstName} ${this.memberLastName}`);

      if (this.data.first_name || this.data.last_name) {
        let salutation = '';
        if (get(this.data.gender, 'value') === 'M') salutation = 'Herr';
        else if (get(this.data.gender, 'value') === 'F') salutation = 'Frau';
        name = trim(`${salutation} ${this.data.first_name} ${this.data.last_name}`);
      }

      return name;
    },
    // company() {
    //   let company = this.form.company;
    //   if (!company && this.address && this.address.company) company = this.address.company;
    //   return company;
    // },
    // companyAddition() {
    //   let companyAddition = this.form.company_addition;
    //   if (!companyAddition && this.address && this.address.company_addition) {
    //     companyAddition = this.address.company_addition;
    //   }
    //   return companyAddition;
    // },

    getterPathPart() {
      let path = 'account.billing_address';
      if (this.type === 'shipping') path = 'shipping';
      return path;
    },
    gender() {
      const genders = [
        {
          value: 'M',
          label: 'Herr'
        },
        {
          value: 'F',
          label: 'Frau'
        },
        {
          value: 'X',
          label: 'Sonstiges'
        }
      ];
      return genders.find(el => el.value === this.data.gender);
    },

    oneLiner() {
      let country = '';
      if (this.data.country) country = countries.getName(this.data.country, 'de');
      return trim(`${this.data.street}, ${this.data.zipcode} ${this.data.city}, ${country}`, ', ');
    },
    ...mapGetters({
      member: 'auth/member',
      isAuthenticated: 'auth/isAuthenticated',
      checkout: 'shop/checkout'
    })
  },
  methods: {
    select() {
      this.$emit('click', this.data);
      if (!this.active) this.$emit('select', this.data);
    }
  }
};
</script>

<style lang="sass">
.empty-checkbox
  @apply flex justify-center items-center
  width: 3rem
  height: 3rem
  .circle
    @apply border-2 border-gray-400
    width: 1.5rem
    height: 1.5rem
    border-radius: 50%
</style>
